const searchToggles = document.querySelectorAll('.js-block-meta__toggle');
if (searchToggles) {
  [].forEach.call(searchToggles, (searchToggle) => searchToggle.addEventListener('click', toggleSearch));
}

function toggleSearch(event) {
  event.preventDefault();

  const searchToggle = event.target;

  searchToggle.setAttribute('aria-expanded', searchToggle.getAttribute('aria-expanded') === 'false');
}

document.addEventListener('click', closeSearchClickOutside);
function closeSearchClickOutside(event) {
  const target = event.target;
  const searchToggles = document.querySelectorAll('.js-block-meta__toggle');

  // If current target is submenu toggle button bail out.
  if (target.matches('.js-block-meta__toggle')) {
    return;
  }

  [].forEach.call(searchToggles,function (searchToggle) {
    const searchForm = searchToggle.nextElementSibling;
    if (searchToggle.getAttribute('aria-expanded') === 'true' && !searchForm.contains(target)) {
      searchToggle.setAttribute('aria-expanded', 'false');
    }
  });
}